module.exports = __webpack_public_path__ + "static/3-997129817a9825a7097633d84032de7c.jpg";